import type { v2 } from '@sap/ux-specification-types';
import { syncRule } from '../../../common/decoration/decorators';
import { getKPISettingsPath } from '../../application';

export class KPISettings implements v2.KPISettings {
    @syncRule({
        manifest: {
            path: (pageKeys, _manifest, KPIKey): string => getKPISettingsPath(pageKeys, KPIKey)
        }
    })
    model: string;

    @syncRule({
        manifest: {
            path: (pageKeys, _manifest, KPIKey): string => getKPISettingsPath(pageKeys, KPIKey)
        }
    })
    entitySet?: string;

    @syncRule({
        manifest: {
            path: (pageKeys, _manifest, KPIKey): string => getKPISettingsPath(pageKeys, KPIKey)
        }
    })
    qualifier?: string;

    @syncRule({
        manifest: {
            path: (pageKeys, _manifest, KPIKey): string => getKPISettingsPath(pageKeys, KPIKey)
        }
    })
    filterable?: boolean;

    @syncRule({
        manifest: {
            path: (pageKeys, _manifest, KPIKey): string => getKPISettingsPath(pageKeys, KPIKey)
        }
    })
    detailNavigation?: string;

    @syncRule({
        manifest: {
            path: (pageKeys, _manifest, KPIKey): string => getKPISettingsPath(pageKeys, KPIKey)
        }
    })
    groupId?: string;
}
